import axios from 'axios';
// import * as queryString from "query-string";

export const detail = {
    getBritaniaDetail() {
        return axios({
            method: 'GET',
            url: `https://origin-console-service.onrender.com/api/detail`,
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },
};